import { Controller } from 'stimulus'

// Reveals the demand-PDF options (editable document title + PDF mention)
// only when the "Disposer d'une impression de la demande" checkbox is ticked.
export default class extends Controller {
  static targets = ['pdfEnabled', 'pdfOptions']

  connect() {
    this.togglePdfOptions()
  }

  togglePdfOptions() {
    if (this.pdfEnabledTarget.checked) {
      this.pdfOptionsTarget.classList.remove('d-none')
    } else {
      this.pdfOptionsTarget.classList.add('d-none')
    }
  }
}
